import { useState } from 'react';
import { Button, Snackbar, Tooltip } from '@mui/material';
import { submitAllUrls } from '../services/indexnow';

/**
 * Pushes the whole site to the IndexNow engines in one go.
 *
 * Ordinary product edits ping automatically, so this is for the two cases that
 * bypass the admin console entirely: a first run, and a bulk migration executed
 * from a script. Those are exactly when the catalogue changes most and when
 * nothing would otherwise announce it.
 *
 * Deliberately not automatic and not on a timer. Repeated full-site submissions
 * are how a host earns a 429 and, eventually, a reputation for crying wolf.
 */
export function SubmitAllToIndexNow() {
  const [busy, setBusy] = useState(false);
  const [message, setMessage] = useState<string | null>(null);

  const submit = async () => {
    setBusy(true);
    try {
      const result = await submitAllUrls();
      setMessage(`${result.submitted} URLs submitted. ${result.message}`);
    } catch (err) {
      setMessage(err instanceof Error ? err.message : 'Submission failed.');
    } finally {
      setBusy(false);
    }
  };

  return (
    <>
      <Tooltip title="Tell Bing, Yandex, Naver, Seznam, Yep and Amazon that every page may have changed. Google does not take part in IndexNow and finds changes through the sitemap instead. Product edits already ping on their own — use this after a bulk migration.">
        <span>
          <Button size="small" onClick={submit} disabled={busy}>
            {busy ? 'Submitting…' : 'Ping search engines'}
          </Button>
        </span>
      </Tooltip>
      <Snackbar
        open={message != null}
        autoHideDuration={8000}
        onClose={() => setMessage(null)}
        message={message ?? ''}
      />
    </>
  );
}
